// extracted by mini-css-extract-plugin
export default {"overlay":"tg-provider_overlay__W5hsG","overlayMobile":"tg-provider_overlayMobile__YgRi0","activedProfileIcon":"tg-provider_activedProfileIcon__P696g"};